import styled from 'styled-components';

export const MatchWidgetWrapper = styled.div`
  margin: ${props => (props.isMobile ? '0 10px 0 20px' : '0 10px')};
`;

export const TitleWrapper = styled.div`
  //border-top: 1px solid ${props => props.theme.colors.gray};
  padding: 5px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const MatchWrapper = styled.div`
  //background-color: ${props => props.theme.colors.mainColor};
  border: 2px solid ${props => props.theme.colors.gray}
`;



// WEBPACK FOOTER //
// ./src/containers/GazzanetWidgets/MatchWidgetGazzanet/styles.js